<template>
  <egg-description
    :eggImgObj="{ componentName: 'bivalentVaccine', imgName: 'family', imgFormat: 'svg', position: 'right' }"
    :starBackgroundRightObj="{ componentName: 'shared', imgName: 'starGroupIconBrownRightS2', imgFormat: 'svg', top: '100%' }"
    :starBackgroundLeftObj="{ componentName: 'shared', imgName: 'starGroupIconBrownLeftSmall', imgFormat: 'svg', bottom: '-280%' }"
    textMode="text"
    footer="bivalentVaccine.vaccinePromotionDescFooter"
    footerCustomStyle="!mt-3"
    class="pb-24"
  >
    <template #customSection>
      <div class="text-3xl font-sanstc flex items-center gap-x-5" style="color: #4e4e4e">
        <img :src="commonStore.getImgUrl('shared', 'starIconSeaBlue', 'svg')" class="" style="width: 1.2vw" />
        <span>{{ t("bivalentVaccine.vaccinePromotionDescPara1") }}</span>
      </div>
      <div class="text-3xl font-sanstc flex items-center gap-x-5" style="color: #4e4e4e">
        <img :src="commonStore.getImgUrl('shared', 'starIconSeaBlue', 'svg')" class="" style="width: 1.2vw" />
        <span>{{ t("bivalentVaccine.vaccinePromotionDescPara2") }}</span>
      </div>
    </template>
  </egg-description>
</template>

<script setup lang="ts">
import { useBivalentVaccineStore } from "@/stores/bivalentVaccine";
import { useCommonStore } from "@/stores/common";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const bivalentVaccineStore = useBivalentVaccineStore();
const commonStore = useCommonStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>